import { Button, TextField } from '@mui/material';
import styled from 'styled-components';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';


/* export const CTextField = styled.TextField`
  border-radius: 100px
` */

export const CButton = styled.button`
  border-radius: 10px;
  width: 100%;
  height: 50px;
  border: none;
  color: white;
  background-color: #B0C4B1;
  font-size: 18px;
  font-weight: 700;
`;

export const CP = styled.p`
  text-align:left
`
